import React from "react";
import { Navigate } from "react-router-dom";
import { GetCookieData } from "../pages/Cookie/GetCookie";

const Authmiddleware = (props) => {

  if (!GetCookieData("userData")) {
    return (
      // <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
      <Navigate to={{ pathname: "/login-eoffice", state: { from: props.location } }} />
    );
  }
  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
